import { createSelector } from "reselect";

const getOfferHeader = (currentOfferHeaderState, _) => {
  const result = Object.assign(currentOfferHeaderState);
  const clientCardVisibilitiesByRole = result.clientCardVisibilitiesByRole;
  if (!(clientCardVisibilitiesByRole && clientCardVisibilitiesByRole.length)) return result;

  for (const roleVisibilities of clientCardVisibilitiesByRole) {
    if (!roleVisibilities.cards || !(roleVisibilities.cards instanceof Array)) continue;
    roleVisibilities.cards = roleVisibilities.cards.reduce(
      (obj, item) => Object.assign(obj, { [item.id]: item.visible }),
      {}
    );
  }
  return result;
};

const getClient = (currentOfferHeaderState, entitiesPartnersState) =>
  entitiesPartnersState[currentOfferHeaderState.client.clientId];

export const getFullOfferHeader = createSelector([getOfferHeader, getClient], (offerHeader, client) => {
  return {
    ...offerHeader,
    client: {
      ...offerHeader.client,
      clientName: client ? client.generalData.partnerName : offerHeader.client.clientName
    }
  };
});

export const getOfferFolderData = state => {
  const { folderId, folderSiteId } = state.currentOffer.header;
  return { folderId, folderSiteId };
};
